import React, { useContext, useState } from 'react';
import Header from '../Common/Header';
import Sidebar from '../Common/Sidebar';
import Footer from '../Common/Footer';
import axios from 'axios';
import { GMCContext } from '../../GMCContext';
import toast from 'react-hot-toast';


export default function ManagePassword() {
    const { setIsSidebarEnabled } = useContext(GMCContext);
    const [oldPassword, setOldPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);


    // Function to toggle password visibility
    const togglePasswordVisibility = () => {
        setPasswordVisible(prevState => !prevState);
    };


    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(prevState => !prevState);
    };


    // Function to update the password
    const updatePassword = async () => {
        if (password !== confirmPassword) {
            toast.error('New Password And Confirm Password Do Not Match.');
            return;
        }

        try {
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: 'adminLogin',
                submethod: 'update',
                username: 'admin',
                oldpassword: oldPassword,
                newpassword: password,
                key: process.env.REACT_APP_KEY,
            });

            // console.log('Response from backend:', res.data);

            if (res.data.status === "1") {
                toast.success(res.data.message || 'Password Updated Successfully!');
                setOldPassword('');
                setPassword('');
                setConfirmPassword('');
            } else {
                toast.error(res.data.message || 'Failed To Update Password');
            }
        } catch (err) {
            toast.error('An Error Occurred While Updating The Password. Please Try Again Later.');
            console.error(err);
        }
    };


    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Proceed with updating the password
        updatePassword();
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div id="layout-wrapper">
                <div className="vertical-overlay" onClick={() => setIsSidebarEnabled(prev => !prev)} />
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between bg-galaxy-transparent">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item">
                                                <a href="javascript:void(0);">Tables</a>
                                            </li>
                                            <li className="breadcrumb-item active">Set New Password</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div className="auth-page-content">
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-md-8 col-lg-6 col-xl-5">
                                            <div className="card mt-4 card-bg-fill">
                                                <div className="card-body p-4">
                                                    <div className="text-center mt-2">
                                                        <h5 className="text-primary">Create New Password</h5>
                                                    </div>
                                                    <div className="p-2">
                                                        {/* Display Success/Error Messages */}
                                                        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                                                        {successMessage && <div className="alert alert-success">{successMessage}</div>}

                                                        <form onSubmit={handleSubmit}>
                                                            <div className="mb-3">
                                                                <label className="form-label" htmlFor="old-password-input">Old Password</label>
                                                                <div className="position-relative auth-pass-inputgroup">
                                                                    <input
                                                                        type={passwordVisible ? "text" : "password"}
                                                                        className="form-control pe-5 password-input"
                                                                        placeholder="Enter old password"
                                                                        id="old-password-input"
                                                                        value={oldPassword}
                                                                        onChange={(e) => setOldPassword(e.target.value)}
                                                                        required
                                                                    />
                                                                    <button
                                                                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon material-shadow-none"
                                                                        type="button"
                                                                        onClick={togglePasswordVisibility}
                                                                    >
                                                                        <i className="ri-eye-fill align-middle" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label" htmlFor="password-input">New Password</label>
                                                                <div className="position-relative auth-pass-inputgroup">
                                                                    <input
                                                                        type={passwordVisible ? "text" : "password"}
                                                                        className="form-control pe-5 password-input"
                                                                        placeholder="Enter new password"
                                                                        id="password-input"
                                                                        value={password}
                                                                        onChange={(e) => setPassword(e.target.value)}
                                                                        required
                                                                    />
                                                                    <button
                                                                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon material-shadow-none"
                                                                        type="button"
                                                                        onClick={togglePasswordVisibility}
                                                                    >
                                                                        <i className="ri-eye-fill align-middle" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="form-label" htmlFor="confirm-password-input">Confirm Password</label>
                                                                <div className="position-relative auth-pass-inputgroup">
                                                                    <input
                                                                        type={confirmPasswordVisible ? "text" : "password"}
                                                                        className="form-control pe-5 password-input"
                                                                        placeholder="Confirm new password"
                                                                        id="confirm-password-input"
                                                                        value={confirmPassword}
                                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                                        required
                                                                    />
                                                                    <button
                                                                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon material-shadow-none"
                                                                        type="button"
                                                                        onClick={toggleConfirmPasswordVisibility}
                                                                    >
                                                                        <i className="ri-eye-fill align-middle" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="mt-4">
                                                                <button className="btn btn-success w-100" type="submit">Reset Password</button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );
}
